exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.custom-chart {\n    width: 100% !important;\n    height: 100% !important;\n    min-height: 350px !important; /* ou la hauteur que tu veux */\n    max-height: 100% !important;\n    position: relative;\n}\n", ""]);

// exports
